import * as Yup from 'yup'

const schema = {
  emergencyContactName: Yup.string()
    .max(50, 'Emergency Contact Name must not exceed 50 characters')
    .required('Emergency Contact Name is required'),
  emergencyContactPhone: Yup.string()
    .max(20, 'Emergency Contact Number must not exceed 20 characters')
    .required('Emergency Contact Number is required')
    .test(
      'not-equal-phoneNumber',
      'Emergency Contact Number must not be equal to Phone number',
      (value, testContext) => {
        if (
          'phoneNumber' in testContext.parent &&
          testContext.parent.phoneNumber.length > 0
        ) {
          return testContext.parent.phoneNumber !== value
        }
        return false
      },
    ),
}
export default schema
